import { postJson } from '@zapier/toolbox-browser-fetch';
import { TrackingMiddleware } from '../types';
import { isBrowser } from '../utils';

const CONTEXT_ENV = isBrowser() ? 'client' : 'server';

const sendToBackend: TrackingMiddleware = config => async event => {
  const { service, baseUrl = '' } = config.get(['service', 'baseUrl']);

  if (event.name.startsWith('schema:')) {
    // If the event.name begins with 'schema:` we'll use the event.name value
    // that follows 'schema:' to represent the Avro schema for the provided
    // event.data.   We'll use the v4 Events API to emit these events.
    const schemaName = event.name.split(':')[1];

    // We'll include additional `context` data in the properties payload.
    // If the Avro schema referenced by event.name does not define a `context`
    // field in the schema definition, this data will be dropped because
    // the v4 events API uses the events_toolkit's ignore_extra_fields mode.
    const url = `${baseUrl}/api/v4/tracking/event/`;
    const { path, identity_id, userAgent: user_agent } = event.context;

    await postJson(url, {
      subject: schemaName,
      properties: {
        ...event.data,
        user_agent,
        identity_id,
        path,
        context: {
          [`${service || ''}__${CONTEXT_ENV}`]: event.context,
        },
      },
    });
  } else {
    // The v3 events API will remain the default while we continue to work
    // on the v4 migration.
    const url = `${baseUrl}/api/v3/events`;

    await postJson(url, {
      message: event.name,
      data: {
        ...event._deprecatedBuildProprtiesInRoot(),
        ...event.data,
        _data: event.data,
        _context: {
          [`${service || ''}__${CONTEXT_ENV}`]: event.context,
        },
      },
    });
  }
};

export default sendToBackend;
